/*
 * @Descripttion:
 * @version:
 * @Author: houhailong
 * @Date: 2023-05-21 07:22:42
 * @LastEditors: Aalon
 * @LastEditTime: 2023-05-21 15:43:32
 */
import { Injectable } from '@angular/core';
import { StandardResponse } from '../models/standard-response';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpHeaderSettings } from '../settings/http-header-settings';
import { map} from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  standardResponse: StandardResponse = {
    data: [],
    success: false,
    message: 'Something went wrong. Please try again later.',
  };

  constructor(private readonly http: HttpClient) {}

  public postForm(url: string, data: any): Observable<StandardResponse> {
    const headers = new HttpHeaders().set(
      HttpHeaderSettings.ContentType,
      HttpHeaderSettings.applicationForm
    );
    return this.http
      .post<StandardResponse>(url, data, {
        headers: headers,
      })
      .pipe(map((data) => data));
  }
  public postJSON(
    url: string,
    data: any,
    needAuth: Boolean = false
  ): Observable<StandardResponse> {
    const headers = new HttpHeaders()
      .set(HttpHeaderSettings.ContentType, HttpHeaderSettings.applicationJson)
      .set(
        HttpHeaderSettings.Authorization,
        needAuth ? HttpHeaderSettings.BasicValue : ''
      );
    return this.http
      .post<StandardResponse>(url, data, {
        headers: headers,
      })
      .pipe(map((data) => data));
  }

  public get(url: string, data: any = null): Observable<StandardResponse> {
    const headers = new HttpHeaders().set(
      HttpHeaderSettings.ContentType,
      HttpHeaderSettings.applicationJson
    );
    return this.http
      .get<StandardResponse>(url, {
        headers: headers,
        params: this.setHttpQueryParameters(data),
      })
      .pipe(map((data) => data));
  }

  private setHttpQueryParameters(_requestData: any) {
    let paramModel: any = new Object();

    if (_requestData != null) {
      for (const key in _requestData) {
        let value = _requestData[key];
        paramModel[key] = value;
      }
    }
    return new HttpParams({ fromObject: paramModel });
  }
}
